<template>
  <div class="living-option-card" :class="{ 'living-option-card--active' : isActive }">
    <transition name="fast-fade">
      <div v-if="isFavourited(slide._id)" class="living-option-card__fav-icon">
        <fa :icon="['far', 'heart']" />
      </div>
    </transition>
    <div class="living-option-card__slide-image">
      <!-- <transition name="fast-fade">
        <div v-if="isActive && slide.virtualTourUrl" class="living-option-card__virtual-overlay" @click="isActive ? openVirtualTour(slide.virtualTourUrl) : () => {}">
          <fa :icon="['fas', 'street-view']"/>
          <div class="text">Virtual Tour</div>
        </div>
      </transition> -->
      <img
        v-if="slide.dwellingOverlayImage"
        class="living-option-card__overlay"
        :src="`${$store.state.assetsPath}${slide.dwellingOverlayImage}`"
      >
      <img
        v-if="slide.packageOverlayImage"
        class="living-option-card__overlay"
        :src="`${$store.state.assetsPath}${slide.packageOverlayImage}`"
      >
      <img v-if="slide.images.length" :src="`${$store.state.assetsPath}${slide.images[0]}`">
    </div>
    <div class="living-option-card__details">
      <div class="dwelling-feature">
        <div v-if="slide.beds" class="dwelling-feature__wrapper">
          <div class="dwelling-feature__icon"><fa :icon="['far', 'bed']"/></div>
          <div class="dwelling-feature__value">{{ slide.beds }}</div>
        </div>
        <div v-if="slide.baths" class="dwelling-feature__wrapper">
          <div class="dwelling-feature__icon"><fa :icon="['far', 'bath']"/></div>
          <div class="dwelling-feature__value">{{ slide.baths }}</div>
        </div>
        <div v-if="slide.cars" class="dwelling-feature__wrapper">
          <div class="dwelling-feature__icon"><fa :icon="['far', 'car']"/></div>
          <div class="dwelling-feature__value">{{ slide.cars }}</div>
        </div>

        <template v-if="styles['general']['show-favourites'] === true">
          <transition name="fast-fade">
            <template v-if="isActive">
              <button 
                v-if="!isFavourited(slide._id)"
                class="btn-circle btn-circle--lime touch"
                @click.stop="addToFavourites(slide)"
              >
                <fa :icon="['far', 'heart']" />
              </button>

              <button 
                v-if="isFavourited(slide._id)"
                class="btn-circle btn-circle--red touch"
                @click.stop="removeFromFavourites(slide)"
              >
                <fa :icon="['far', 'trash']" />
              </button>
            </template>
            
          </transition>
        </template>
      </div>

      <div class="property-feature">
        <div v-if="slide.name" class="property-feature__wrapper">
          <div
            class="property-feature__label"
            :style="`color: ${styles['property-card']['heading-colour']};`"
          >Name</div>
          <div class="property-feature__value">{{ slide.name }}</div>
        </div>

        <div v-if="slide.builder" class="property-feature__wrapper">
          <div
            class="property-feature__label"
            :style="`color: ${styles['property-card']['heading-colour']};`"
          >Builder</div>
          <div class="property-feature__value">{{ slide.builder }}</div>
        </div>

        <div v-if="slide.colourScheme" class="property-feature__wrapper">
          <div
            class="property-feature__label"
            :style="`color: ${styles['property-card']['heading-colour']};`"
          >Colour Scheme</div>
          <div class="property-feature__value">{{ slide.colourScheme }}</div>
        </div>

        <div v-if="slide.houseDesign" class="property-feature__wrapper">
          <div
            class="property-feature__label"
            :style="`color: ${styles['property-card']['heading-colour']};`"
          >House Design</div>
          <div class="property-feature__value">{{ slide.houseDesign }}</div>
        </div>

        <div v-if="slide.lotNumber && slide.type !== 'dwelling'" class="property-feature__wrapper">
          <div
            class="property-feature__label"
            :style="`color: ${styles['property-card']['heading-colour']};`"
          >Lot Number</div>
          <div class="property-feature__value">{{ slide.lotNumber }}</div>
        </div>

        <div v-if="slide.price" class="property-feature__wrapper">
          <div
            class="property-feature__label"
            :style="`color: ${styles['property-card']['heading-colour']};`"
          >Price</div>
          <div class="property-feature__value">{{ slide.price.toLocaleString('en-AU', { style: 'currency', currency: 'AUD', maximumSignificantDigits: 10 }) }}</div>
        </div>
 
        <div v-if="slide.lotSize" class="property-feature__wrapper">
          <div
            class="property-feature__label"
            :style="`color: ${styles['property-card']['heading-colour']};`"
          >Lot Area</div>
          <div class="property-feature__value">{{ slide.lotSize }}m<sup>2</sup></div>
        </div>

        <div v-if="slide.dwellingSize" class="property-feature__wrapper">
          <div
            class="property-feature__label"
            :style="`color: ${styles['property-card']['heading-colour']};`"
          >Floor Area</div>
          <div class="property-feature__value">{{ slide.dwellingSize }}m<sup>2</sup></div>
        </div>

        <div v-if="slide.minimumFrontage" class="property-feature__wrapper">
          <div
            class="property-feature__label"
            :style="`color: ${styles['property-card']['heading-colour']};`"
          >Minimum Frontage</div>
          <div class="property-feature__value">{{ slide.minimumFrontage }}m</div>
        </div>

        <div class="property-feature__btn-wrapper">
          <transition name="fast-fade">
            <button
              v-show="isActive && slide.virtualTourUrl && isMatterportAvailable"
              class="btn touch"
              style="bottom: 2.4rem;"
              @click.stop="openVirtualTour(slide.virtualTourUrl)"
            >
              <span>Virtual Tour</span>
            </button>
          </transition>
          <transition name="fast-fade">
            <button
              v-show="isActive" 
              class="btn touch"
              @click.stop="openModal(slide._id)"
            >
              <span>Details</span>
            </button>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: ['slide', 'isActive'],

  data () {
    return {
      isMatterportAvailable: false,
    }
  },

  computed: {
    favourites () {
      return this.$store.getters['favourites/favourites']
    },

    favouriteIds () {
      return this.$store.state.favourites.favouriteIds
    },

    env () {
      return process.env
    },

    styles () {
      return this.$store.getters['styleTemplate']
    }
  },

  async mounted () {
    this.isMatterportAvailable = await this.fetchMatterportAvailability()
  },

  methods: {
    ...mapActions([
      'fetchMatterportAvailability'
    ]),

    addToFavourites (slide) {
      this.$store.commit('favourites/ADD_TO_FAVOURITES', slide._id)
    },

    isFavourited (slideId) {
      let isFavourited = false
      this.favouriteIds.forEach(favouriteId => {
        if (favouriteId === slideId) {
          isFavourited = true
        }
      }) 

      return isFavourited
    },

    openModal (id) {
      const routeName = this.$store.state.route.name
      const category = this.$store.getters.activeCategory

      if (routeName === 'packages') {
        this.$router.push(`/${category}/live/packages/${id}`)
      }

      if (routeName === 'dwellings') {
        this.$router.push(`/${category}/live/dwellings/${id}`)
      }

      if (routeName === 'turnkeys') {
        this.$router.push(`/${category}/live/turnkeys/${id}`)
      }

      if (routeName === 'favourites') {
        this.$router.push(`/${category}/favourites/${id}?p=${this.favouriteIds.toString()}`)
      }
    },

    openVirtualTour (url) {
      this.$store.commit('property/SET_ACTIVE_VIRTUAL_TOUR_URL', url)
      this.$store.commit('sidebar/CLOSE_SLIDEOUT')
    },

    removeFromFavourites (slide) {
      this.$store.commit('favourites/REMOVE_FROM_FAVOURITES', slide._id)
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/_variables.scss";
@import "@/styles/_mixins.scss";
@import "@/styles/_buttons.scss";

$transition-speed: 300ms;

.living-option-card {
  display: flex;
  background: #212122;
  border-radius: $default-border-radius;
  box-shadow: rgba($black, 0.6) 0.1rem 0.2rem 0.4rem;
  flex-direction: column;
  flex-shrink: 0;
  height: 45rem;
  opacity: 1;
  overflow: hidden;
  position: relative;
  transition: box-shadow $transition-speed ease-in-out, opacity $transition-speed ease-in-out;
  width: 100%;

  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1;
  }

  &__fav-icon {
    background: $lime;
    border-radius: 0;
    border-bottom-left-radius: .5rem;
    color: $black;
    height: 3.5rem;
    padding: .65rem;
    position: absolute;
    right: -1px;
    top: -1px;
    width: 2.5rem;
    z-index: 2;

    svg {
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
      font-size: 1.2rem;
    }
  }

  &__slide-image {
    flex-shrink: 0;
    height: 42%;
    position: relative;
    width: 100%;

    img {
      bottom: 0;
      height: 100%;
      left: 0;
      object-fit: cover;
      position: absolute;
      right: 0;
      top: 0;
      width: 100%;
    }
  }

  &__virtual-overlay {
    align-items: center;
    background: rgba(0, 0, 0, .6);
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    pointer-events: auto;
    position: absolute;
    width: 100%;
    z-index: 1;

    svg {
      font-size: 4rem;
    }

    .text {
      font-size: 1.1rem;
      margin: 1em 0 0;
      text-transform: uppercase;
    }
  }

  &__details {
    display: flex;
    height: 100%;
    padding: 2rem;

    .dwelling-feature {
      align-items: flex-start;
      display: flex;
      flex-direction: column;
      width: 28%;

      &__wrapper {
        align-items: center;
        display: flex;
        justify-content: center;
        margin: 0 1rem .5rem 0;
      }

      &__icon {
        align-items: center;
        border: .1rem solid $lime;
        border-radius: 50%;
        color: $lime;
        display: flex;
        font-size: 1.1rem;
        justify-content: center;
        height: 2.2rem;
        width: 2.2rem;

        svg {
          color: $white;
        }
      }

      &__value {
        margin: .25rem 0 0 .35rem;
      }

      .btn-circle {
        font-size: 1.1rem;
        margin: auto auto 0 0;
        transform-origin: bottom left;

        height: 2.2rem;
        width: 2.2rem;
      }
    }

    .property-feature {
      // display: flex;
      // flex-direction: column;
      display: block;
      position: relative;
      width: 72%;

      &__wrapper {
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
        margin: 0 0 .5rem;
      }

      &__label {
        color: $lime;
        font-size: .7rem;
        text-transform: uppercase;
      }

      &__value {
        font-size: .9rem;
        line-height: 1.1;
        text-transform: uppercase;
      }

      &__btn-wrapper {
        align-items: flex-end;
        display: flex;
        height: 100%;
      }

      .btn {
        bottom: 0;
        color: $white;
        font-size: .9rem;
        font-weight: 300;
        height: 2.2rem;
        line-height: 0;
        margin: auto auto 0 0;
        padding: .2rem 0 0;
        position: absolute;
        transform: scale(.75);
        transform-origin: left;
        width: 133%;
      }
    }
  }

  &__actions {
    bottom: .5rem;
    display: flex;
    flex-direction: column;
    margin: auto 0 0;
    opacity: 1;
    padding: 0 2rem;
    position: absolute;
    transform: scale(.75);
    transition: transform $transition-speed ease-in-out;
    width: 100%;

    .btn {
      margin: 0 auto 1.25em;
      width: 100%;

      &:last-child {
        margin: 0 auto;
      }
    }
  }
}
</style>